export const MAIN_URL = process.env.ENTRY || '/';
export const API_BASE_URL = `${MAIN_URL}api/`;

// FOR LOCAL PRODUCTION TESTS
// export const API_BASE_URL = `https://www.stage5.cop.inlearno.info/api/`;



// WEBPACK FOOTER //
// ./src/config/consts/index.js